<template>
  <div class="row justify-center">
    <div class="col-xs-12 col-sm-10 col-md-8" style="padding-top: 40px" v-if="!finished">
      <h5>Verify Your Identity</h5>
    </div>
    <div v-if="!initialised" class="col-xs-12 col-sm-10 col-md-8">
      <p class="q-mb-lg">Verify your identity in 2 easy steps</p>
      <div class="row q-gutter-x-sm">
        <div class="q-pa-lg cursor-pointer column text-center col bdr-a-grey-5 rounded-borders-lg bdr-dashed" @click="$emit('start')">
          <QIcon style="height: auto" :name="`img:${icons.selfie}`" color="primary" class="full-width" />
          <span class="text-weight-bold q-mt-lg"> STEP 1: </span>
          <p class="q-mt-sm">Upload Driver’s Licence</p>
        </div>
        <div class="q-pa-lg cursor-pointer column text-center col bdr-a-grey-5 rounded-borders-lg bdr-dashed" @click="$emit('start')">
          <QIcon style="height: auto" :name="`img:${icons.photoId}`" color="primary" class="full-width" />
          <span class="text-weight-bold q-mt-lg"> STEP 2: </span>
          <p class="q-mt-sm">Take a Selfie</p>
        </div>
      </div>
      <QBtn
        color="primary"
        class="full-width"
        label="Start Now"
        :loading="started"
        no-caps
        @click="$emit('start')"
        style="margin-top: 25px"
      />
    </div>
    <div v-if="finished" class="col-xs-12 col-sm-10 col-md-8" style="text-align: center; padding: 100px 0">
      <QSpinner color="primary" size="3em" />
    </div>
    <div v-if="!error && !finished" class="col-xs-12 col-sm-10 col-md-8">
      <div id="id-scan"></div>
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { QIcon, QBtn, QSpinner } from 'eclipx.ui';

export default {
  name: 'IDScan',
  props: {
    started: Boolean,
    initialised: Boolean,
    finished: Boolean,
    error: Boolean,
    icons: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({ orgProfile: 'theme/getScoreboard' })
  },
  components: {
    QIcon,
    QBtn,
    QSpinner
  }
};
</script>
